/**
 * Created by fgallucci on 17/06/2020.
 */

import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getTranslationsTableFromIstanceID } from 'App/actions'
import { resetSidebarStore } from 'src/App/actions'
import './index.scss'

function Translations({ history, location, match }) {
  const { t } = useTranslation('Shell')

  const { url, params } = match
  const { instanceId } = params

  useEffect(() => {
    const fetchWTs = async () => {
      const translations = await getTranslationsTableFromIstanceID(t)
      // If url and location.pathname are the same
      // we are not showing a translation table detail yet.
      if (url === location.pathname && translations) {
        if (translations.length) {
          // Open the first available translationTable
          history.replace(translations[0].href)
        }
      }
    }
    fetchWTs()
  }, [instanceId, t]) // TODO: handle language change without refetch, possibly

  // On component unmount empties sidebar list
  useEffect(() => {
    return resetSidebarStore
  }, [])

  return null
}

export default React.memo(Translations)
